var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.41 12.59L6.83 8L11.41 3.41L10 2L4 8L10 14L11.41 12.59Z",
    fill: "#FB263B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevRed);
export default __webpack_public_path__ + "static/media/prevRed.f40ce6e4d2c1b30721cffa40cd3e2731.svg";
export { ForwardRef as ReactComponent };